import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "react-image-gallery/styles/css/image-gallery.css";
import "./assets/scss/style.scss";

import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Preloader from "./components/Preloader";
import CustomScrollbar from "./components/CustomScrollbar";

import Index from "./pages/Index";
import Media from "./pages/Media";
import Gillidanda from "./pages/Gillidanda";
import Jachigi from "./pages/Jachigi";
import KibbelKabbel from "./pages/KibbelKabbel";
import KondaKondi from "./pages/KondaKondi";
import Lippa from "./pages/Lippa";
import Syatong from "./pages/Syatong";
import Tipcat from "./pages/Tipcat";
import Pandolo from "./pages/Pandolo";
import DandiBiyo from "./pages/DandiBiyo";
import Quimbumbia from "./pages/Quimbumbia";
import Rules from "./pages/Rules";

const App = () => {
  const { pathname } = useLocation();

  return (
    <>
      <Preloader />
      <CustomScrollbar />
      <div className="main-wrapper">
        <Header type={pathname !== "/" ? "navigation-1" : ""} />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/prensa" element={<Media />} />
          <Route path="/gillidanda" element={<Gillidanda />} />
          <Route path="/jachigi" element={<Jachigi />} />
          <Route path="/kibbelkabbel" element={<KibbelKabbel />} />
          <Route path="/kondakondi" element={<KondaKondi />} />
          <Route path="/syatong" element={<Syatong />} />
          <Route path="/lippa" element={<Lippa />} />
          <Route path="/tipcat" element={<Tipcat />} />
          <Route path="/pandolo" element={<Pandolo />} />
          <Route path="/dandibiyo" element={<DandiBiyo />} />
          <Route path="/quimbumbia" element={<Quimbumbia />} />
          <Route path="/reglas" element={<Rules />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
};

export default App;
